import { render } from "./updatePwd.vue?vue&type=template&id=635f62d5&scoped=true"
import script from "./updatePwd.vue?vue&type=script&lang=js"
export * from "./updatePwd.vue?vue&type=script&lang=js"

import "./updatePwd.vue?vue&type=style&index=0&id=635f62d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635f62d5"]])

export default __exports__